import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import CompanyProductLayer from "./CompanyProductLayer";


const CompanyProductPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Components / Company Categories" />

        {/* CompanyCategoryLayer */}
        < CompanyProductLayer/>

      </MasterLayout>
    </>
  );
};

export default CompanyProductPage;
